import { Controller, useFormContext } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const IsEntity = ({ index }: { index: number }) => {
  const { control, setValue } = useFormContext<SarEdit>()
  return (
    <Controller
      name={`subjectsInfo.${index as 0}.isEntity`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="3. Check"
          input={(props) => (
            <CheckBox
              {...props}
              checkBoxLabel="If entity"
              onChange={(value) => {
                if (value) {
                  setValue(`subjectsInfo.${index as 0}.firstName`, '')
                  setValue(`subjectsInfo.${index as 0}.middleName`, '')
                  setValue(`subjectsInfo.${index as 0}.suffix`, '')
                  setValue(`subjectsInfo.${index as 0}.gender`, '')
                  setValue(`subjectsInfo.${index as 0}.birthdate`, null)
                }
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
